import { version } from "./constants.js";
const UV1 = version >= 125 ? "uv1" : "uv2";
export {
  UV1
};
//# sourceMappingURL=uv1.js.map
